import React, {Component} from "react";
import styles from './FJMusicCategory.module.less';
import InlineSVG from "react-inlinesvg";
import ArrowIcon from '../../../../../icon/arrow-left.svg';
import FJButton from 'fj-components/FJButton'
import classNames from 'classnames';
import FJLocalStore from "../../../../../store/FJLocalStore";

class FJMusicCategory extends Component {

	constructor(props) {
		super(props);
		this.state = {
			active: true
		}
	}

	_transform = (str) => {
		let _str = str.replace(/-/g, ' ');
		return _str.replace(_str[0], _str[0].toUpperCase());
	};

	_headClick = () => {
		this.setState({
			active: !this.state.active
		})
	}

	renderCateItem = () => {
		let {items, cate, onChange, filter} = this.props
		if (!items || !items.length) return;
		let lists = [];
		let value = filter[cate]
		items.map(item => {
			return lists.push(
								<FJButton key={item}
													text={this._transform(FJLocalStore._(item))}
													className={classNames(styles.item, {[styles.active]: item === value})}
													textClass={styles.item_text}
													onClick={() => {if (onChange) {onChange(cate, item)}}}
								/>
							)
		})

		return lists;
	}


	render() {
		let {active} = this.state;
		let {cate} = this.props;
		return (
			<div className={classNames(styles.category, {[styles.active]: active})}>
				<div className={classNames(styles.cate_head, {[styles.active]: active})} onClick={this._headClick}>
					<span className={styles.head_text}>{this._transform(FJLocalStore._(cate))}</span>
					<InlineSVG src={ArrowIcon}/>
				</div>
				<div className={styles.cate_body}>
					{this.props.children}
					{this.renderCateItem()}
				</div>
			</div>
		)
	}
}

export default FJMusicCategory;